<template>
    <footer class="bg-abaco-footer" style="padding-bottom: 3rem">
      <div class="container w-100">
        <div class="row d-sm-none d-md-none d-lg-none d-xl-none" style="margin-top: 1rem">
          <div class="col-8">
            <footer-contact></footer-contact>
          </div>
          <div class="col-4">
            <img src="@/assets/footer/colombia-fintec@2x.png" width="70%">
          </div>
          <div class="col-12" style="margin-top: 2rem;">
            <span class="info-abacolatam-com">Proyecto subvencionado por</span>
          </div>
          <div class="col-4">
            <img src="@/assets/footer/union-euro@2x.png" style="max-width:100%; max-height:100%">
          </div>
          <div class="col-4">
            <img src="@/assets/footer/ia-asturias@2x.png" style="max-width:100%; max-height:100%">
          </div>
          <div class="col-4">
            <img src="@/assets/footer/idepa@2x.png" style="max-width:100%; max-height:100%">
          </div>
        </div>

        <div class="row d-none d-sm-inline-flex w-100" style="margin-top: 1rem">
          <div class="col-sm-4 col-md-3">
            <footer-contact></footer-contact>
          </div>
          <div class="col-sm-3 col-md-2">
            <img src="@/assets/footer/colombia-fintec@2x.png" width="60%">
          </div>
          <div class="d-sm-none d-md-block col-md-1" style="margin-top: 2rem;">
          </div>
          <div class="col-sm-4 col-md-6 text-right">
            <span class="info-abacolatam-com">Proyecto subvencionado por</span><br>
            <img src="@/assets/footer/union-euro@2x.png" class="footer-image-desktop">
            <img src="@/assets/footer/ia-asturias@2x.png" class="footer-image-desktop">
            <img src="@/assets/footer/idepa@2x.png" class="footer-image-desktop">
          </div>
        </div>
      </div>
    </footer>
</template>

<script>
import FooterContact from './partials/FooterContact'
export default {
  name: 'Footer',
  components: {FooterContact},
  methods: {
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style>
footer {
  background-color: #FBF3EC;
  margin: 0;
  padding: 10px
}
.contacto {
  height: 22px;
  width: 66px;
  color: #333333;
  font-family: "Source Serif Pro";
  font-size: 1.1rem;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 22px;
}
.info-abacolatam-com {
  height: 48px;
  width: 150px;
  color: #333333;
  font-size: 0.8em;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
}
.footer-image-desktop {
  max-width: 20%;
  vertical-align: top;
}
.footer-link {
  text-decoration: none;
}
@media (max-width: 768px) {
  .footer-image-desktop {
    max-width: 30%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue